import { render, staticRenderFns } from "./download.vue?vue&type=template&id=abf7a898&scoped=true&"
import script from "./download.js?vue&type=script&lang=js&"
export * from "./download.js?vue&type=script&lang=js&"
import style0 from "./download.css?vue&type=style&index=0&id=abf7a898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf7a898",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
